import { render, staticRenderFns } from "./RemarkDialog.vue?vue&type=template&id=5ecdd7ba"
import script from "./RemarkDialog.vue?vue&type=script&lang=js"
export * from "./RemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./RemarkDialog.vue?vue&type=style&index=0&id=5ecdd7ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports